/**
 * Land Purchase & Verification hub — register with the global subcategory registry.
 * The same hub is surfaced under Legal as "Land & Property Law" (`/legal/land-property-law`).
 */
import { LAND_PURCHASE_AND_VERIFICATION_SLUG, landPurchaseVerificationDefaultData } from "./landPurchaseData";
import { LandPurchaseArticlesTab, LandPurchaseMediaTab, LandPurchaseOverviewTab } from "./LandPurchaseDesign";

const landPurchaseViews = {
  overview: LandPurchaseOverviewTab,
  articles: LandPurchaseArticlesTab,
  media: LandPurchaseMediaTab,
};

export const landPurchaseVerificationModule = {
  slug: LAND_PURCHASE_AND_VERIFICATION_SLUG,
  getDefaultData: () => landPurchaseVerificationDefaultData,
  Views: landPurchaseViews,
};

/** Mirrors land purchase hub for the Legal mega-menu slug. */
export const landPropertyLawLegalModule = {
  slug: "land-property-law",
  getDefaultData: () => landPurchaseVerificationDefaultData,
  Views: landPurchaseViews,
};
